import {growthbookCacheAtom} from 'atoms/growthbook';
import {ROUTE_PATHS} from 'constant';
import {useAtomValue} from 'jotai';
import {Navigate, useLocation} from 'react-router';
import {HOME_DIRECTORY_STATE, isHomeDirectoryOn} from 'views/home/homeDirectory';

import {People} from './People';

/**
 * When home is the directory, /people sends you there. The query string
 * comes along, so `/people?s=kyle` opens that search.
 */
export const PeopleRoute = () => {
  const flags = useAtomValue(growthbookCacheAtom);
  const {search} = useLocation();

  if (isHomeDirectoryOn(flags)) {
    return (
      <Navigate to={{pathname: ROUTE_PATHS.HOME, search}} state={HOME_DIRECTORY_STATE} replace />
    );
  }

  return <People />;
};
